import { Stack } from '@mui/material';
import { getTreatments, ITreatment } from 'API/Treatment/treatment';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { useCallback, useEffect, useState } from 'react';
import { Entitlement } from './Entitlement';
import { TreatmentSupplier } from './TreatmentSupplier';
import { RecentOrdersSection } from './RecentOrdersSection';
import { NoTreatmentDataFound } from './NoTreatmentDataFound';
import { useLoader } from 'Hooks/useLoader';
import { TreatmentTitle } from './TreatmentTitle';
import { ExtraEntitlementsPrevYearAlert } from './ExtraEntitlementsPrevYearAlert';
import { isBefore } from 'date-fns';

export const Treatment = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);
  const isDesktop = useIsDesktop();
  const { isLoading, setIsLoading, loader } = useLoader();
  const [treatmentData, setTreatmentData] = useState<ITreatment>();

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const initTreatment = useCallback(() => {
    (async () => {
      setIsLoading(true);
      const data = await getTreatments();
      if (data) setTreatmentData(data);
      setIsLoading(false);
    })();
  }, [setIsLoading]);

  useEffect(() => {
    initTreatment();
  }, [initTreatment, imposterId]);

  const isDataMissing = !(
    treatmentData &&
    treatmentData.entitlements &&
    treatmentData.entitlements.length > 0
  );

  return (
    <Stack marginBottom={'88px'}>
      <CustomMetaTitle title={dictionary.metaTitle} />
      <Stack gap={isDesktop ? '54px' : '24px'}>
        <LinkReturnToMain />
        {isLoading ? (
          loader
        ) : (
          <>
            {isDataMissing ? (
              <NoTreatmentDataFound />
            ) : (
              <Stack gap={isDesktop ? '40px' : '24px'}>
                <TreatmentTitle />
                {isLoading ? (
                  loader
                ) : (
                  <>
                    {treatmentData.entitlements.some((entitlement) =>
                      isBefore(
                        new Date(entitlement.daysBalanceStartDate),
                        new Date(2024, 0, 1)
                      )
                    ) && <ExtraEntitlementsPrevYearAlert />}
                    <Stack maxWidth={'820px'} gap={isDesktop ? '64px' : '48px'}>
                      <Entitlement data={treatmentData.entitlements} />
                      <TreatmentSupplier userId={imposterId} />
                      <RecentOrdersSection data={treatmentData.orders} />
                    </Stack>
                  </>
                )}
              </Stack>
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};
